import { ID, CollectionQueryParams } from './common';

export enum SourceType {
    FILE = 'FILE',
    CAMERA = 'CAMERA',
    FLIR = 'FLIR',
}

const SOURCE_TYPE_VALUES = new Set<string>(Object.values(SourceType));

export function parseEngineSourceType(
    raw: string | undefined | null,
): SourceType | undefined {
    if (raw == null || raw === '') {
        return undefined;
    }
    const token = raw.includes('.') ? raw.split('.').pop()! : raw;
    const key = token.trim().toUpperCase();
    return SOURCE_TYPE_VALUES.has(key) ? (key as SourceType) : undefined;
}

export function getSelectableSourceType(type: SourceType): SourceType {
    return type === SourceType.FLIR ? SourceType.CAMERA : type;
}

export enum SourceStatus {
    UPLOADING = 'UPLOADING',
    PENDING = 'PENDING',
    FIXING = 'FIXING',
    QUEUED = 'QUEUED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
}

export interface Source {
    id: ID;
    createdAt: number;
    updatedAt: number;
    src: string | null;
    name: string;
    duration: number;
    type: SourceType;
    fps: number;
    width: number;
    height: number;
    status: SourceStatus;
    statusDetails: string | null;
    progress: number;
    userId: ID;
    location: { name: string };
    folderIds: ID[];
}

export interface FullSource extends Omit<Source, 'userId'> {
    displayName: string;
    isOwner: boolean;
    isShared: boolean;
}

export type SourceVisibility = 'all' | 'private' | 'organization';

export type SourcesSelection =
    | { kind: 'private' }
    | { kind: 'organization' }
    | { kind: 'folder'; id: string };

export type SourceQueryParams = CollectionQueryParams & {
    type?: SourceType;
    status?: SourceStatus;
    visibility?: SourceVisibility;
    includeFolders?: boolean;
};

export type UpdateSourcePayload = Pick<Source, 'name'>;

export type ReadyStage = 'off' | 'on' | 'exit';
